module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("Ikraam’s eyes flew open, and he blushed. Fathi noticed Ikraam was uncomfortable with him this close. He briefly thought about the years Ikraam must have spent keeping people at arm’s length so they wouldn’t discover his secret.")]), _vm._v(" But closer up, Fathi noticed his long lashes and the amber flecks in Ikraam’s eyes. His hair was thick and loose, falling to his waist, not contained by the head covering Sabah had given him. Ikraam’s veil was sheer enough that Fathi could see his full lips. Fathi noted Ikraam was the right height to kiss and cuddle in private.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“Fathi?” Ikraam asked breathlessly.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0